<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.lhlb">
      </p>
      <p>
        <br>
      </p>
      <p>
        <br>
      </p>
      <p>
        <b>
          <u>
            <span style="font-size:16.0pt;font-family:宋体;">Combined Drawing Machine</span>
          </u>
        </b>
        <b>
          <u>
            <span style="font-size:16.0pt;font-family:Arial;"></span>
          </u>
        </b>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">&nbsp;</span>
      </p>
      <div>
        <table align="left" cellpadding="0" cellspacing="0">
          <tbody>
            <tr>
              <td align="left" valign="top">
                <p>
                  <span
                    style="font-size:12.0pt;font-family:宋体;color:#2F3032;"
                  >The combined drawing machine is a pipe and bar processing equipment widely used in the non-ferrous metal and ferrous metal industries. On the basis of digesting and absorbing foreign technology, our company has developed a series of</span>
                  <span style="font-size:12.0pt;font-family:Arial;color:#2F3032;">20</span>
                  <span style="font-size:12.0pt;font-family:宋体;color:#2F3032;">～</span>
                  <span style="font-size:12.0pt;font-family:Arial;color:#2F3032;">150KN</span>
                  <span
                    style="font-size:12.0pt;font-family:宋体;color:#2F3032;"
                  >double-sided cylindrical cam combined drawing machines. It has a number of patented technologies, and according to user requirements, single-line drawing, tandem double-drawing or triple-drawing can be set.</span>
                  <span style="font-size:12.0pt;font-family:宋体;">Our products are exported to Ukraine and other countries.</span>
                  <span style="font-size:12.0pt;font-family:Arial;"></span>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;color:#2F3032;">
          <br>
        </span>
        <b>
          <span style="font-size:12.0pt;font-family:宋体;color:#2F3032;">The main features are as follows:</span>
        </b>
        <b>
          <span style="font-size:12.0pt;font-family:Arial;color:#2F3032;">
            <br>
          </span>
        </b>
        <span style="font-size:12.0pt;font-family:宋体;color:#2F3032;">
          <span>★</span>It adopts integrated design of electromechanical and hydraulic, and realizes production automation through human-machine interactive operation.
        </span>
        <span style="font-size:12.0pt;font-family:Arial;color:#2F3032;">
          <br>
        </span>
        <span style="font-size:12.0pt;font-family:宋体;color:#2F3032;">
          <span>★</span>The drawing cart changing hands is controlled by cam and closed hydraulic circuit, which is sensitive and reliable.
        </span>
        <span style="font-size:12.0pt;font-family:Arial;color:#2F3032;">
          <br>
        </span>
        <span style="font-size:12.0pt;font-family:宋体;color:#2F3032;">
          <span>★</span>Equipped with automatic and manual operation modes to meet different process requirements of the production line.
        </span>
        <span style="font-size:12.0pt;font-family:Arial;color:#2F3032;">
          <br>
        </span>
        <span style="font-size:12.0pt;font-family:宋体;color:#2F3032;">
          <span>★</span>Multiple core heads can be loaded at one time and only one head is driven, reducing material consumption and enabling high-speed continuous drawing.
        </span>
        <span style="font-size:12.0pt;font-family:Arial;color:#2F3032;">
          <br>
        </span>
        <span style="font-size:12.0pt;font-family:宋体;color:#2F3032;">
          <span>★</span>The elongation coefficient of single pass stretching can reach
        </span>
        <span style="font-size:12.0pt;font-family:Arial;color:#2F3032;">λ=1.5</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#2F3032;">～</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#2F3032;">1.8</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#2F3032;">.</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#2F3032;">
          <br>
        </span>
        <span style="font-size:12.0pt;font-family:宋体;color:#2F3032;">
          <span>★</span>
        </span>
        <span style="font-size:12.0pt;font-family:Arial;color:#2F3032;">&nbsp;</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#2F3032;">It can realize various production schemes and flexible processes, such as coil-to-coil and coil-to-straight fixed-length drawing of tube blanks.</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#2F3032;">
          <br>
        </span>
        <span style="font-size:12.0pt;font-family:宋体;color:#2F3032;">
          <span>★</span>
        </span>
        <span style="font-size:12.0pt;font-family:Arial;color:#2F3032;">&nbsp;</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#2F3032;">Straight drawing has better wall thickness deviation and roundness than coil drawing.</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#2F3032;">
          <br>
        </span>
        <span style="font-size:12.0pt;font-family:宋体;color:#2F3032;"></span>
        <span style="font-size:12.0pt;font-family:Arial;color:#2F3032;"></span>
      </p>
      <p>
        <b>
          <span style="font-size:12.0pt;font-family:宋体;color:#2F3032;">Equipment Composition</span>
        </b>
        <b>
          <span style="font-size:12.0pt;font-family:Arial;color:#2F3032;">
            <br>
          </span>
        </b>
        <span
          style="font-size:12.0pt;font-family:宋体;color:#2F3032;"
        >The tandem combined drawing machine consists of the mechanical equipment, lubrication equipment, electrical systems, hydraulic and pneumatic systems. Mechanical equipment includes the unwinding, straightening and pinching, indenter, drawing host, cooling, buffer loop, cutting, rewinding device (or fixed-size flying saw) and so on.</span>
      </p>
      <p>
        <br>
      </p>
      <p>
        <br>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        lhlb: require("../../../assets/img/common/lhlb.jpg")
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/ew/device/lhlb.vue